import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { ConfirmDialog } from "primereact/confirmdialog";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';

const EmployeeActivator = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
  const [confirmChangeStatus, setConfirmChangeStatus] = useState(false);

  const acceptLabel = (
    <div style={{ color: 'white' }}>
      <FontAwesomeIcon icon={faCheck} />&nbsp; Yes
    </div>
  );

  const rejectLabel = (
    <div>
      <FontAwesomeIcon icon={faXmark} />&nbsp; No
    </div>
  );
	
	useEffect(() => {
		if (props.editData) {
			setConfirmChangeStatus(true);
		}
	}, [props.editData]);
	
	const handleCancel = () => {
		setConfirmChangeStatus(false);
		props.onHide();
	};

	const UpdateUserStatus = (_data) => {
		let functionName = "";
		try {
			functionName = props.page + UpdateUserStatus.name;
			props.onLoading(
				true,
				(_data.STATUS === "Active" ? "Deactivating" : "Activating") +
				" user, please wait...",
			);

      setConfirmChangeStatus(false);

			const data = {
				USER_MST_GUID: _data.USER_ID,
				USERNAME: _data.USERNAME,
				ACTIVE_FLAG: (_data.STATUS === "Active" ? "N" : "Y"),
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};
			const action = data.ACTIVE_FLAG === "Y" ? "Activate" : "Deactivate";
			
			http
				.post("api/profile/UpdateEmployeeStatus", data, { timeout: 5000 })
				.then((response) => {
					toast.success("Employee is successfully " + action + "d.");
					props.onReload();
				})
				.catch((err) => {
					toast.error("Failed to " + action + " Employee. Please try again.1");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
			toast.error("Failed to " + action + " User. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};

	return (
		<>
			<ConfirmDialog
        visible={confirmChangeStatus}
        onHide={handleCancel}
        content={({ headerRef, contentRef, footerRef, hide }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '2rem',
              backgroundColor: '#fff',
              borderRadius: '12px',
              boxShadow: '0 0 10px rgba(0,0,0,0.15)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: '#0d6efd',
                color: 'white',
                width: '106px',
                height: '106px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '-78px',
                fontSize: '3rem',
              }}
            >
              <i className="pi pi-question" style={{ fontSize: '2.5rem' }} />
            </div>
        
            <div ref={headerRef} style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
              Confirmation
            </div>
            <p ref={contentRef} style={{ marginTop: '1rem', fontSize: '1rem' }}>
              Are you sure you want to {props.editData?.STATUS === "Active" ? "deactivate" : "activate"} this user?
            </p>
            <div ref={footerRef} style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <Button
                label={rejectLabel}
                outlined
                style={{ width: '6rem' }}
                onClick={(e) => {
                  hide(e);
                  handleCancel();
                }}
              />
              <Button
                label={acceptLabel}
                style={{ border: 'none', width: '6rem' }}
                onClick={(e) => {
                  hide(e);
                  UpdateUserStatus(props.editData);
                }}
              />
            </div>
          </div>
        )}
        className="custom-confirm-dialog"
      />
		</>
	);
};

export default EmployeeActivator;